<template>
	<ul class="list-options__views">
		<li class="btn-2col" :class="{ active: largeMode }">
			<a @click.prevent="switchMode(true)" href="#" data-column="2col">2欄</a>
		</li>
		<li class="btn-multi" :class="{ active: !largeMode }">
			<a @click.prevent="switchMode(false)" href="#" data-column="multi">多欄</a>
		</li>
	</ul>
</template>

<script>
export default {
	name: "GridMode",
	props: ["largemode"],
	data() {
		return {
			largeMode: this.largemode,
		};
	},
	methods: {
		switchMode(mode) {
			this.largeMode = mode;
			this.$emit("changegrid", mode);
		},
	},
};
</script>

<style></style>
